
(() => {
  const selector = '[data-hk-pdp-sticky-nav]';

  function findTextTarget(text) {
    if (!text) return null;
    const search = text.trim().toLowerCase();
    const nodes = document.querySelectorAll(
      'h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,[class*="title" i],[class*="heading" i]'
    );

    for (const node of nodes) {
      const value = (node.textContent || '').trim().toLowerCase();
      if (value === search || (value.length < 70 && value.includes(search))) {
        return node.closest('.shopify-section') || node;
      }
    }
    return null;
  }

  function resolveTarget(button) {
    const target = (button.dataset.target || '').trim();
    const label = (button.dataset.label || '').trim();

    if (target === '__overview__') {
      const productInfo = document.querySelector('product-info');
      return productInfo?.closest('.shopify-section') || productInfo;
    }

    if (target === '__specs__') {
      return document.querySelector('.hkh-specs')
        || findTextTarget('Technical Specifications')
        || findTextTarget('Specifications');
    }

    if (target) {
      const byId = document.getElementById(target);
      if (byId) return byId;

      try {
        const byClass = document.querySelector(`.${CSS.escape(target)}`);
        if (byClass) return byClass;
      } catch (_) {}

      const byText = findTextTarget(target);
      if (byText) return byText;
    }

    return findTextTarget(label);
  }

  function setActive(root, button) {
    root.querySelectorAll('[data-hk-pdp-tab]').forEach((tab) => {
      const active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function updateStickyTop(root) {
    const host = root.closest('.shopify-section');
    if (!host) return;

    const header = document.querySelector(
      'sticky-header, .header-wrapper, #shopify-section-header, header'
    );

    let top = 0;
    if (header) {
      const rect = header.getBoundingClientRect();
      top = Math.max(0, rect.bottom);
    }
    host.style.top = `${top}px`;
  }

  function readVariantMap(root) {
    const script = root.querySelector('[data-hk-sticky-variants]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (_) {
      return {};
    }
  }

  function initRoot(root) {
    if (root.dataset.hkStickyInitialized === 'true') return;
    root.dataset.hkStickyInitialized = 'true';

    const host = root.closest('.shopify-section');
    if (host) host.classList.add('hk-pdp-sticky-host');

    const tabs = [...root.querySelectorAll('[data-hk-pdp-tab]')];
    const targetPairs = tabs
      .map((tab) => ({ tab, target: resolveTarget(tab) }))
      .filter((item) => item.target);

    tabs.forEach((tab, index) => {
      if (index === 0) setActive(root, tab);

      tab.addEventListener('click', () => {
        const target = resolveTarget(tab);
        setActive(root, tab);
        if (!target) return;

        const rootHeight = root.getBoundingClientRect().height;
        const hostTop = parseFloat(host?.style.top || '0') || 0;
        const y =
          target.getBoundingClientRect().top
          + window.scrollY
          - rootHeight
          - hostTop
          - 8;

        window.scrollTo({
          top: Math.max(0, y),
          behavior: 'smooth'
        });
      });
    });

    let ticking = false;
    const onScroll = () => {
      updateStickyTop(root);

      if (ticking || !targetPairs.length) return;
      ticking = true;

      requestAnimationFrame(() => {
        const offset = (root.getBoundingClientRect().height || 0) + 24;
        let current = targetPairs[0];

        for (const pair of targetPairs) {
          if (pair.target.getBoundingClientRect().top <= offset) {
            current = pair;
          }
        }

        if (current?.tab) setActive(root, current.tab);
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => updateStickyTop(root), { passive: true });
    onScroll();

    const variantMap = readVariantMap(root);
    const hiddenId = root.querySelector('[data-hk-sticky-variant-id]');
    const submit = root.querySelector('[data-hk-sticky-submit]');
    const submitText = root.querySelector('[data-hk-sticky-submit-text]');
    const price = root.querySelector('[data-hk-sticky-product-price]');
    const image = root.querySelector('[data-hk-sticky-product-image]');

    function syncVariant(id, fallbackVariant) {
      if (!id) return;

      const key = String(id);
      const data = variantMap[key] || fallbackVariant || {};

      if (hiddenId) hiddenId.value = key;

      const available =
        typeof data.available === 'boolean'
          ? data.available
          : true;

      if (submit) submit.disabled = !available;

      if (submitText) {
        submitText.textContent = available
          ? (submit?.dataset.addLabel || 'Add to cart')
          : (submit?.dataset.soldLabel || 'Sold out');
      }

      if (price && data.price) {
        price.textContent = data.price;
      }

      const imageUrl =
        data.image
        || data.featured_media?.preview_image?.src
        || data.featured_image?.src
        || null;

      if (image && imageUrl) {
        image.src = imageUrl;
      }
    }

    function handleVariantEvent(event) {
      const variant =
        event?.data?.variant
        || event?.detail?.variant
        || event?.detail
        || null;

      if (variant?.id) syncVariant(variant.id, variant);
    }

    if (
      window.theme?.pubsub?.subscribe
      && window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange
    ) {
      window.theme.pubsub.subscribe(
        window.theme.pubsub.PUB_SUB_EVENTS.variantChange,
        handleVariantEvent
      );
    }

    document.addEventListener('variant:change', handleVariantEvent);
    document.addEventListener('variant-change', handleVariantEvent);
  }

  function initAll() {
    document.querySelectorAll(selector).forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();
